import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { Project } from "@/types";
import { api, UnprocessableEntityError } from "@/utils/api";
import { camelize, underscore } from "@/utils/api-helpers";

export type CreateProjectInput = {
  name: string;
};

const createProject = async (input: CreateProjectInput): Promise<Project> => {
  const response = await api.post<Project>("/projects", underscore(input));
  return camelize(response.data);
};

export const useCreateProject = (
  options: Omit<UseMutationOptions<Project, UnprocessableEntityError, CreateProjectInput, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<Project, UnprocessableEntityError, CreateProjectInput, unknown>({
    mutationFn: createProject,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects"]
      })
    },
    ...options
  });
};
